import { combineReducers } from "redux";

import loading from "./loading";
import notifications from "./notifications";
import menu from "./menu";
import user from "./user";
import company from "./company";
import types from "./types";
import platforms from "./platforms";
import quickAnswers from "./quickAnswers";
import chats from "./chats";
import history from "./history";
import draft from "./draft";
import panel from "./panel";
import calls from "./calls";

export default combineReducers({
	loading,
	notifications,
	menu,
	user,
	company,
	types,
	platforms,
	quickAnswers,
	chats,
	history,
	draft,
	panel,
	calls,
});
